<template>
<div class="mt-3">
<div>
    <button  type="button" @click="syncProduct()"  class="btn btn-success">
       <i class="fas fa-external-link-alt mr-2" aria-hidden="true"></i>
       SINCRONIZZA PER BERTINIGROUP.IT
      <span v-if="bt_spinner"  class="spinner-border spinner-border-sm ml-3" role="status" aria-hidden="true"></span>
    </button>     
    <div v-if="show_response">          
              TOKEN {{ token_msg }}  
              
              <div v-if="response1.status == 200" class="alert alert-success mt-2" role="alert">                        
                {{ response1.statusText }}             
              </div>
              
              <div v-if="response1.status  && response1.status != 200" class="alert alert-danger mt-2" role="alert">                        
                {{ response1 }} 
              </div>    
              
              <div v-if="response2.status == 200" class="alert alert-success mt-2" role="alert">                        
                {{ response2.statusText }}                                                       
              </div>
              
              <div v-if="response2.status  && response2.status != 200" class="alert alert-danger mt-2" role="alert">                        
                {{ response2 }} 
              </div>  
              
              <div v-if="response3.status == 200" class="alert alert-success mt-2" role="alert">                        
                {{ response3.statusText }}                                                       
              </div>
              
              <div v-if="response3.status  && response3.status != 200" class="alert alert-danger mt-2" role="alert">
                        
                        {{ response3 }} 

              </div>  
        </div>
            
</div>
</div>
</template>

<script>



import api                from "@/api"
import { mapGetters }     from 'vuex';

export default {
   props : ['productId'],
   components: {},  
  
  data () {
    return {

      
      bt_spinner      : false,
      
      response1       : {},
      response2       : {},
      response3       : {},
      response4       : {},
      
      token_msg       : '',
      show_response   : false

    }
  },
  computed: 
  {
   
    ...mapGetters(['company']),
     
  },
   
  created()
  {
    //console.log('ProductId',this.productId)
    //this.getData()
   
  },

  methods: 
  {

    async getBertiniToken()
    {
     
      return new Promise( async (resolve, reject)  =>  {
      await api.bertini.getToken().then(res => {
        
          if(res.status==200)
            {
              
              resolve(res.data.token)
              
            }
             
           else
            {
              const token = ''
              resolve(token)
              
            } 
      

          }).catch(err => {
            const token = ''
              resolve(token)
              
          }).finally(() => {
                this.bt_spinner = false
        });
      })

    },

   
    async syncProduct()
    {
     
      this.bt_spinner   = true      
      const token = await this.getBertiniToken()
    
      if(token)
      {
        this.token_msg = ''
        const today = new Date();
      
        this.token_msg = token + ' ' + today.toLocaleDateString()
    
        const data     = await this.getBertiniProductData(this.productId)
      
        const product  = {product: data[0][0] }
        const variants = this.getBertiniVariants(data[1])
        const stock    = this.getBertiniStock(data[1])
        const seo      = this.getBertiniSeo(product)
        
        
        this.show_response = false

        const response1 = await api.bertini.postProduct(product,token)  
        
        this.response1 = response1
        if(this.response1.status == 200)
        {
          this.response1.statusText =  'Sincronizzazione Prodotto effettuata con successo.'
        }
        
        console.log('Res1',response1.status)

        const response2 = await api.bertini.postVariants(variants,token)  
        this.response2 = response2

        if(this.response2.status == 200)
        {
          this.response2.statusText =  'Sincronizzazione Varianti prodotto effettuata con successo.'
        }  

        console.log('Res2',response2)

        const response3 = await api.bertini.postStock(stock,token)  

        this.response3 = response3
        if(this.response3.status == 200)
        {
          this.response3.statusText =  'Sincronizzazione Stock  effettuata con successo.'
        }

        console.log('Res3',response3)

        const response4 = await api.bertini.postSeo(seo,token)  
        this.response4 = response4
        console.log('Res4',response4)
        
        this.bt_spinner = false
        this.show_response= true


        
      }

      
    },

    getBertiniVariants(items)
    {
      let data = {'variants':[]}
      items.forEach(item => {
        item.additional_informations = JSON.stringify({'CODICE_FORNITORE': item.codice_fornitore,'EAN':item.EAN})
        item.product_code = item.product_code.toString()
        data.variants.push(item)
      })
      return data
    },
    getBertiniStock(items)
    {
      let data = {'variants':[]}
      items.forEach(item => {
        data.variants.push({'product_code':item.product_code,'variant_code':item.variant_code,'warehouse_id':'1','stock':item.stock.toString()})
      })

      return data
    },
    getBertiniSeo(item)
    {
      
      let data = {'product':{'product_code':item.product.product_code,'variant_code':'','title':item.product.description,"id_store_view":"1"}}
      

      return data
    },
    getBertiniProductData(productId)
    {
       const sp       = {'sp':'spSyncBertiniMax'}
       const data     = {'productId' : productId}
       
       this.bt_spinner = true

       const json = Object.assign(data, sp);
      
       return new Promise( async (resolve, reject)  =>  {

        await api.post(json).then(res => {
                  
          if(res.status==200)
            {
              
              

              if(res.data.recordsets[0].length > 0)
              {
                
                resolve(res.data.recordsets)
              }
              else
              {
                resolve([])
              }
              
            }
           else if(res.status==500)
           {
              resolve([])
              /*
              this.msg.title = 'ATTENZIONE '                              
              this.msg.body = res.data              
              this.msg.type = 1               
              resolve(false)
              */
                                    
           } 
           else
            {
              resolve([])
              /*
              this.msg.title = 'ATTENZIONE '  
              this.msg.body = res 
              this.msg.type = 1                          
              resolve(false)
              */
            } 
          

          }).catch(err => {
              
              resolve([])
              /*
              this.msg.title = 'ATTENZIONE '
              this.msg.body = err.message 
              this.msg.type = 1                
              */
          }).finally(() => {
              
              this.bt_spinner = false
        });
        
        
        
       })      
    },
   
    
    
    
  

     
   
    
   
    
    

    
      
  }
  
}
</script>

<style scoped>
    
</style>